import { FeatureFlagIdNewNav2026 } from 'c1gen/features'
import { ModularC1Nav } from 'components/modular-nav'
import { useFeatureChecker } from 'components/no-ui/capability'
import { FC } from 'react'

import { Sidebar } from './Sidebar'

export const SidebarWrapper: FC = () => {
    const hasNewNav = useFeatureChecker(FeatureFlagIdNewNav2026)

    if (hasNewNav) {
        return <ModularC1Nav />
    }

    return <Sidebar />
}
